import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 100%;
  margin-bottom: 16px;

  .MuiAutocomplete-root {
    width: 100%;
  }

  .MuiInputBase-root {
    background-color: #FFFFFF;
    border-radius: 8px;

    &:hover {
      background-color: #F9F9F9;
    }

    &.Mui-disabled {
      background-color: #F5F5F5;
    }
  }

  .MuiInputLabel-root {
    color: #666;
    font-weight: 500;

    &.Mui-focused {
      color: #89BD23;
    }
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: #E0E0E0;
  }

  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #BDBDBD;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #89BD23;
  }

  .MuiAutocomplete-tag {
    margin: 2px;
  }

  .MuiAutocomplete-inputRoot {
    padding: 8px 12px;
    gap: 4px;
    flex-wrap: wrap;
  }

  .MuiAutocomplete-input {
    min-width: 120px !important;
  }

  .MuiAutocomplete-popupIndicator {
    color: #666;

    &:hover {
      background-color: rgba(137, 189, 35, 0.04);
    }
  }

  .MuiAutocomplete-clearIndicator {
    color: #666;

    &:hover {
      background-color: rgba(137, 189, 35, 0.04);
    }
  }

  .MuiAutocomplete-paper {
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin-top: 4px;
  }

  .MuiAutocomplete-option {
    &:hover {
      background-color: rgba(137, 189, 35, 0.08);
    }

    &.Mui-focused {
      background-color: rgba(137, 189, 35, 0.12);
    }
  }
`;

